import React from "react";
import { useStaticQuery, graphql } from "gatsby";
import { Logo } from "../../layout/Logo";
import { WrapperComponent, WrapperText } from "../../Style/SellingCss";

const WebKuu = ({ paragraph }) => {
  const { rightIconWebKuu, leftIconWebKuu } = useStaticQuery(graphql`
    query {
      rightIconWebKuu: file(relativePath: { eq: "svg/RightIconWebKuu.svg" }) {
        publicURL
      }
      leftIconWebKuu: file(relativePath: { eq: "svg/LeftIconWebKuu.svg" }) {
        publicURL
      }
    }
  `);

  return (
    <WrapperComponent>
      <div className="logo">
        <Logo style={{ maxWidth: 200 }} />
      </div>
      <WrapperText
        backgroundRight={rightIconWebKuu.publicURL}
        backgroundLeft={leftIconWebKuu.publicURL}
      >
        {paragraph}
      </WrapperText>
    </WrapperComponent>
  );
};

export default WebKuu;
